import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    variant: 'backgrounds.gradient3',
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '12px',
    padding: ['42px 24px 38px', '30px 40px 35px'],
    color: 'white',
    maxWidth: ['1280px'],
    margin: ['72px 20px', '146px 20px', '146px auto'],
    flexDirection: ['column', 'row'],
    borderStyle: 'solid',
    borderWidth: '1.5px',
    '&.no-margin': {
      margin: ['0px 28px', '0 auto'],
    },
  },
  mainContainerLeft: {},
  mainContainerRight: {
    display: 'flex',
    maxWidth: ['560px'],
    maxHeight: ['374px'],
    marginLeft: [null, '50px'],
    marginTop: ['41px', 'initial'],
    minWidth: '50%',
    justifyContent: 'flex-end',
    alignSelf: ['center', 'stretch'],
    width: ['100%', 'fit-content'],
  },
  title: {
    marginBottom: ['32px'],
  },
  bodyText: {
    marginBottom: ['40px', '80px'],
  },
  image: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
  },
  cta: {
    margin: ['0 auto', 'inherit'],
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    paddingY: ['121px', '52px'],
  },
};
